// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see AppMessageInteractClickEvent
 */
export var AppMessageInteractClick = function (_a) {
    var clickedAt = _a.clickedAt, customerToken = _a.customerToken, externalId = _a.externalId, format = _a.format, messageToken = _a.messageToken, urlOpened = _a.urlOpened;
    return ({
        name: "AppMessage Interact Click",
        parameters: {
            cdf_entity: "AppMessage",
            cdf_action: "Interact",
            clicked_at: clickedAt !== undefined && clickedAt !== null ? clickedAt.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            customer_token: customerToken !== undefined && customerToken !== null ? customerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            external_id: externalId !== undefined && externalId !== null ? externalId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            format: format !== undefined && format !== null ? format.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            message_token: messageToken !== undefined && messageToken !== null ? messageToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            url_opened: urlOpened !== undefined && urlOpened !== null ? urlOpened.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AppMessageInteractViewEvent
 */
export var AppMessageInteractView = function (_a) {
    var customerToken = _a.customerToken, externalId = _a.externalId, format = _a.format, messageToken = _a.messageToken, viewedAt = _a.viewedAt;
    return ({
        name: "AppMessage Interact View",
        parameters: {
            cdf_entity: "AppMessage",
            cdf_action: "Interact",
            customer_token: customerToken !== undefined && customerToken !== null ? customerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            external_id: externalId !== undefined && externalId !== null ? externalId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            format: format !== undefined && format !== null ? format.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            message_token: messageToken !== undefined && messageToken !== null ? messageToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            viewed_at: viewedAt !== undefined && viewedAt !== null ? viewedAt.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AppMessageInteractBufferEvent
 */
export var AppMessageInteractBuffer = function (_a) {
    var bufferTimeMillis = _a.bufferTimeMillis, messageToken = _a.messageToken;
    return ({
        name: "AppMessage Interact Buffer",
        parameters: {
            cdf_entity: "AppMessage",
            cdf_action: "Interact",
            buffer_time_millis: bufferTimeMillis !== undefined && bufferTimeMillis !== null ? bufferTimeMillis.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            message_token: messageToken !== undefined && messageToken !== null ? messageToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AppMessageInteractTapShareButtonEvent
 */
export var AppMessageInteractTapShareButton = function (_a) {
    var externalId = _a.externalId, format = _a.format, messageToken = _a.messageToken;
    return ({
        name: "AppMessage Interact TapShareButton",
        parameters: {
            cdf_entity: "AppMessage",
            cdf_action: "Interact",
            external_id: externalId !== undefined && externalId !== null ? externalId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            format: format !== undefined && format !== null ? format.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            message_token: messageToken !== undefined && messageToken !== null ? messageToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AppMessageInteractShareCompletedEvent
 */
export var AppMessageInteractShareCompleted = function (_a) {
    var externalId = _a.externalId, format = _a.format, messageToken = _a.messageToken, shareOption = _a.shareOption, completed = _a.completed;
    return ({
        name: "AppMessage Interact ShareCompleted",
        parameters: {
            cdf_entity: "AppMessage",
            cdf_action: "Interact",
            external_id: externalId !== undefined && externalId !== null ? externalId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            format: format !== undefined && format !== null ? format.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            message_token: messageToken !== undefined && messageToken !== null ? messageToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            share_option: shareOption !== undefined && shareOption !== null ? shareOption.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            completed: completed !== undefined && completed !== null ? completed.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
